<template>
  <!-- 教师专业发展综合积分排行榜 -->
  <div class="top1 clearfix">
    <h1>各项积分趋势</h1>
    <div class="big-box clearfix">
      <div
        v-for="(item, index) in listData"
        :key="index"
        :index="index"
        class="box fl clearfix"
      >
        <div style="height: 100%" class="chart-class" ref="chartLine"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    searchYear: null,
    searchTerm: null,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      listData: [],
      defaultUrl: require(`@/assets/image/other/headMan.png`),
      pageObj: {
        current: 1,
        total: 0,
        size: 4,
        sizeList: [4, 8, 12],
      },
    };
  },
  created() {
    this.rankLsit();
  },
  methods: {
    //教师专业发展综合积分排行榜
    rankLsit() {
      let homeForm = {
        regionId: this.userInfo.teacherSchoolList[0].provinceId,
        teacherId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
        schoolTerm: this.searchTerm || null,
        schoolYear: this.searchYear || null,
      };
      this.$axios
        .post("/teacherScore/getTeacherModelScoreTrendLine", homeForm)
        .then((res) => {
          if (res.resultCode === 200 && res.data.length > 0) {
            this.listData = res.data;
            this.$nextTick(() => {
              this.initCharts();
            });
          } else {
            this.listData = [];
          }
        })
        .catch((err) => {
          console.log("教师error", err);
        });
    },
    initCharts() {
      for (let i = 0; i < this.listData.length; i++) {
        let chartLine = this.$echarts.init(this.$refs.chartLine[i]);
        chartLine.setOption({
          title: {
            text: this.listData[i].name,
            left: "center",
            bottom: "5px",
            textStyle: {
              color: "#333",
              fontSize: 16,
              fontWeight: "normal",
            },
          },
          legend: {},
          tooltip: {
            trigger: "axis",
            showContent: false,
          },
          color: ["#13C2C2", "#2FC25B", "#FACC14", "#F04864", "#8543E0"],
          xAxis: {
            type: "category",
          },
          yAxis: { type: "value", gridIndex: 0 },
          dataset: { source: this.listData[i].data },
          series: this.listData[i].data
            .slice(0, this.listData[i].data.length - 1)
            .map((u) => ({
              type: "line",
              seriesLayoutBy: "row",
              emphasis: { focus: "series" },
            })),
        });
      }
    },
    checkMore() {
      this.$nextTick(() => {
        // 新增节点后，结构全部渲染后,才能拿到最后的chart节点
        this.rankLsit();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top1 {
  background-color: #fff;
  h1 {
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    margin: 0 20px;
  }
  .big-box {
    background-color: #fff;
    margin: 0 30px;
    padding: 30px 0;
    .box {
      cursor: pointer;
      // width: 600px;
      width: 30%;
      height: 300px;
      margin-bottom: 24px;
      box-sizing: border-box;
      margin-right: 24px;
      background: #ebfaf3;
      border-radius: 7px;
      padding: 20px 24px;
      .tu {
        height: 300px;
        margin-top: 5px;
      }
    }
  }
}
</style>
